<template>
  <div
    class="product-grid-teaser"
    :class="`products-count__${products.length}`"
  >
    <a
      :href="link && link.url ? link.url : false"
      :target="link && link.openLinkInNewWindow ? '_blank' : ''"
      class="product-grid-teaser__headline"
      :class="[
        headlineBgColor ? headlineBgColor : '',
        textColor ? textColor : ''
      ]"
    >
      {{ headline }}
    </a>
    <div
      class="product-grid-teaser__wrapper"
    >
      <div
        v-for="(product, index) in products"
        :key="index"
        class="products-list__tiles__element products-list__tiles__element--type_product products-list__tiles__element--type_product--grid-teaser"
        :class="{
          'products-list__tiles__element--type_product--grid-teaser--no-bottom': (products.length - index <= elementsPerRow)
        }"
      >
        <product-box
          class="products-list__product-box"
          v-bind="product"
          :index="index"
          :list-view="false"
        />
      </div>
    </div>
  </div>
</template>

<script>

  import ProductBox from '../productBox/productBox.vue';
  import { breakpoints } from "../../variables/variables";

  export default {
    components: {
      ProductBox
    },
    props: {
      products: {
        type: Array,
        default() {
          return [];
        }
      },
      headline: {
        type: String
      },
      link: {
        type: Object,
        default() {
          return {};
        }
      },
      headlineBgColor: {
        type: String
      },
      textColor: {
        type: String
      }
    },
    data() {
      return {
        twoColumns: window.innerWidth < breakpoints.tablet
      }
    },
    created() {
      window.addEventListener('breakpointChange', this.breakpointChangeHandler.bind(this));
    },
    methods: {
      breakpointChangeHandler() {
        this.twoColumns = window.innerWidth < breakpoints.tablet;
      },
    },
    computed: {
      elementsPerRow() {
        return this.twoColumns ? 2 : 4;
      }
    },
  };

</script>
